import { Badge, Button } from 'react-bootstrap';
import React from 'react';
import CustomerSummary from '../../../components/lakeview/CustomerSummary';
import StayStatusIcon, {
  stayStatusMapping,
} from '../../../components/lakeview/StayStatusIcon';
import {
  paymentStatusMapping,
  renderPaymentStatus,
} from '../../../helpers/renders/paymentStatusMapping';
import Tooltip from '../../../components/tooltip/Tooltip';

const columns = [
  {
    label: 'Numer',
    field: 'businessId',
    sort: 'desc',
    width: 53,
  },
  {
    label: 'Klient',
    field: 'customer',
    sort: 'desc',
    width: 53,

    type: 'custom',
    custom: function (column, row, navigate) {
      return <CustomerSummary customer={row.customer} />;
    },
  },
  {
    label: 'Status',
    field: 'stayStatus',
    sort: 'desc',
    width: 53,
    type: 'custom',
    custom: function (column, row, navigate) {
      return (
        <h3>
          <StayStatusIcon reservation={row} />
        </h3>
      );
    },
  },
  {
    label: 'Status płatności',
    field: 'paymentStatus',
    sort: 'desc',
    width: 53,
    type: 'custom',
    custom: function (column, row, navigate) {
      return (
        <h3>
          {renderPaymentStatus(row.paymentStatus, 'p-2 ms-2', true, true)}
        </h3>
      );
    },
  },
  {
    field: 'alarm',
    label: 'Alarm',
    sort: 'desc',
    width: 53,
    type: 'custom',
    custom: function (column, row, t) {
      if (row.paymentDueExpired) {
        return (
          <>
            <Tooltip tooltip={'Minął termin płatności'}>
              <h4>
                <i className="fas fa-info-circle text-danger" />
              </h4>
            </Tooltip>
          </>
        );
      }
    },
  },
  {
    label: 'Przyjazd',
    field: 'startDate',
    sort: 'desc',
    width: 53,
  },
  {
    label: 'Wyjazd',
    field: 'endDate',
    sort: 'desc',
    width: 53,
  },
  {
    field: 'reservationChannel',
    label: 'Źródło',
    sort: 'desc',
    width: 53,
    type: 'custom',
    custom: function (column, row, t) {
      if (row.reservationChannel === 'WWW') {
        return (
          <>
            <Badge variant={'primary'}>Strona</Badge>
          </>
        );
      } else {
        return (
          <>
            <Badge text={"dark"} bg={'light'  }>Panel</Badge>
          </>
        );
      }
    },
  },
];

export default columns;
